import './PlatformRecipient.css'

import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { IonHeader, IonItem, IonPage, useIonLoading, useIonAlert, IonContent, IonLabel, IonInput, IonButton, IonToolbar, IonButtons, IonIcon, IonGrid, IonRow, IonCol, IonTitle } from "@ionic/react"
import { PropsWithChildren, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppHeader from "../../../components/AppHeader/AppHeader";
import { ebioroApi, useAddBeneficiaryMutation, useUpdateBeneficiaryMutation } from "../../../services/api/ebioro/ebioro";
import { useAppDispatch, useAppSelector } from "../../../services/redux/hook";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { BeneficiaryRequestParams, BeneficiaryResponse, UserInfo } from '../../../types/types';
import { arrowBackOutline } from 'ionicons/icons';
import RecipientPage from '../RecipientPage';

interface WalletUserResponse {
    stellar_address: string;
    alias: string;
}

interface Props extends PropsWithChildren {

    beneficiary?: BeneficiaryResponse,
}

const PlatformRecipientPage: React.FC<Props> = ({ beneficiary }) => {

    const dispatch = useAppDispatch();
    const nav = document.querySelector("ion-nav");
    const { t, i18n } = useTranslation();
    // // const history = useHistory();
    // const [hideKeepTypingLabel, setHideKeepTypingLabel] = useState(true);
    // const [searchValue, setSearchValue] = useState<string>('');
    const [presentLoading, dismissLoading] = useIonLoading();
    const [present] = useIonAlert();
    const [walletUser, setWalletUser] = useState<any>();
    const userInfo: UserInfo = useAppSelector((state) => state.user);
    const [addBeneficiary, result] = useAddBeneficiaryMutation();
    const [updateBeneficiary, updateBeneficiaryResult] = useUpdateBeneficiaryMutation();

    const [pageHader, setPageHeader] = useState<string>(t('addRecipientPlatform.HEADER') as string);
    const [labelButton, setLabelButton] = useState<string>(t('addRecipient.BTN_LABEL') as string);
    const [disableAliasInput, setDisableAliasInput] = useState<boolean>(false);

    const {
        handleSubmit,
        control,
        setValue,
        register,
        getValues,
        formState: { isValid, errors },
    } = useForm({
        defaultValues: {
            alias: '',
            name: ''
        },
    });

    const presentErrorAlert = (error: string) => {
        present({
            header: "Error",
            message: `${error}`,
            buttons: [
                {
                    text: "Close",
                    role: "cancel",
                    handler: () => {
                        return;
                    },
                },
            ],
        });
    };


    const addPlatformRecipient = async (walletUser: WalletUserResponse, walletUserName: string) => {

        const params: BeneficiaryRequestParams = {

            type: 'individual',
            account_type: 'payment_identifier',
            user_id: userInfo.id,
            payment_id: walletUser.alias,
            payment_id_name: walletUserName,
            stellar_account: walletUser.stellar_address

        }

        if (beneficiary) {

            params.id = beneficiary.id;

            try {

                await updateBeneficiary(params).unwrap();

            } catch (error: any) {

                const message = `${error.message}`;
                presentErrorAlert(message);
                return;

            }

        }

        else {

            try {

                await addBeneficiary(params).unwrap();

            } catch (error: any) {

                presentErrorAlert(error);
                return;
            }
        }

    }


    const onSubmit = async () => {

        const data = getValues();

        try {

            await presentLoading();

            const response: WalletUserResponse = await dispatch(ebioroApi.endpoints.getWalletUser.initiate(data.alias.toLocaleLowerCase())).unwrap();

            if (Capacitor.getPlatform() !== 'web') {

                await Keyboard.hide();

            }

            await addPlatformRecipient(response, data.name);

            setTimeout(async () => {

                await dismissLoading();

                nav?.push(() => <RecipientPage />);
            }, 500)

        } catch (error: any) {

            await dismissLoading()

            if (error.status === 404) {

                presentErrorAlert(`${t('addRecipientPlatform.NOT-FOUND-1')} ${data.alias} ${t('addRecipientPlatform.NOT-FOUND-2')}`);
                return;

            }

            presentErrorAlert(t('application.uncaught.ERROR'))

        }

    };

    useEffect(() => {

        if (beneficiary) {

            setValue('alias', beneficiary.payment_id as string);
            setValue("name", beneficiary.payment_id_name as string);
            setDisableAliasInput(true);
            setPageHeader(t('updateRecipient.HEADER') as string);
            setLabelButton(t('updateRecipient.BTN_LABEL') as string)

        }


    }, [])

    return (
        <IonPage>

            <IonHeader className="ion-no-border">

                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonButtons slot='start'>
                        <IonButton color='primary' onClick={() => { nav?.pop() }}>
                            <IonIcon slot='icon-only' icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle> {pageHader}</IonTitle>
                </IonToolbar>

                

            </IonHeader>
            <IonContent>
                <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 18 }}>


                    <IonGrid style={{ marginTop: '5%' }}>
                        <IonRow>
                            <IonCol>

                                <div>
                                    {/* === ION INPUT TAG=== */}
                                    <IonInput
                                        style={{textAlign:'left'}}
                                        mode='md'
                                        label={t('addRecipientPlatform.ALIAS-LABEL') as string}
                                        fill="outline"
                                        labelPlacement="floating"
                                        disabled={disableAliasInput}
                                        placeholder={t('addRecipientPlatform.ALIAS-PLACEHOLDER') as string}
                                        {...register('alias', {
                                            required: 'User tag is required',

                                        })}
                                    />
                                </div>
                                <ErrorMessage
                                    errors={errors}
                                    name="alias"
                                    as={<div style={{ color: 'red' }} />}
                                />

                            </IonCol>
                        </IonRow>
                        {/* === ION INPUT NAME=== */}
                        <IonRow style={{ marginTop: '10%' }}>
                            <IonCol>

                                <div>

                                    <IonInput
                                        style={{textAlign:'left'}}
                                        mode='md'
                                        labelPlacement="floating"
                                        label={t('addRecipientPlatform.NAME-LABEL') as string}
                                        fill="outline"
                                        placeholder={t('addRecipientPlatform.NAME-PLACEHOLDER') as string}
                                        {...register('name', {
                                            required: 'Name is required',

                                        })}
                                    />
                                </div>
                                <ErrorMessage
                                    errors={errors}
                                    name="name"
                                    as={<div style={{ color: 'red' }} />}
                                />

                            </IonCol>
                        </IonRow>
                    </IonGrid>

                    <IonButton
                        color={'primary'}
                        className="platformRecipientButtonAdd"
                        type="submit"
                        expand="block"
                    >
                        {labelButton}
                    </IonButton>

                </form>
            </IonContent>

        </IonPage>
    )
}

export default PlatformRecipientPage;